import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	Output,
} from '@angular/core';

@Component({
	selector: 'spr-block-title',
	templateUrl: './block-title.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class:
			'p-border-color-component-background h-10 flex text-xl leading-10 ' +
			'font-medium border items-center flex-row border-solid ' +
			'border-l-0 border-r-0',
	},
})
export class BlockTitleComponent {
	@Input() public backIcon: string;

	@Input() public showBack: boolean;

	@Input() public contentClass: string;

	@Input() @HostBinding('class.border-t-0') public first: boolean;

	@Output() public goBack = new EventEmitter<void>();
}
